import { Component, OnInit } from '@angular/core';

import { VocabularyService } from '../../services/vocabulary/vocabulary.service';
import { LocalContentService } from '../../services/local-content/local-content.service'
import { AnalyticsService } from '../../services/analytics/analytics.service'

@Component({
  selector: 'app-search',
  templateUrl: 'search.page.html',
  styleUrls: ['search.page.scss']
})
export class SearchPage implements OnInit {
  constructor(public vS: VocabularyService, private localContentService: LocalContentService,
    private analyticsService: AnalyticsService) {
  }

  public wordList = [];
  public pageList = [];
  public filteredWordList = [];
  public searchWord: string = "";
  public selectedWord = "";
  public showPages = false;

  ngOnInit() {
    this.localContentService.getStaticContent().subscribe((data) => {
      this.analyticsService.logEvent("open_screen","search");
      const addWord = (word, page) => {
        word = word.trim();
        if (!word) return;
        let entry = this.wordList.find((ent) => ent.word == word);
        if (!entry) {
          entry = { word: word, links: [] };
          this.wordList.push(entry);
        }
        entry.links.push(page);
      }

      const addPage = (pageRef) => {
        let p = data.pages[pageRef];
        if (!p || (!p.content) || (!p.content.title)) return;
        if (!p.content.indexWords) return; //no words
        if (p.content.__LANGFALLBACK__) return; // don't include english fallback words
        console.log("adding page",p);
        let words = p.content.indexWords.split(';');
        words.forEach((word) => addWord(word, p))
      }
      this.wordList = [];
      Object.keys(data.pages).forEach(pr => addPage(pr))
      this.wordList = this.wordList.sort((a, b) => (a.word.toUpperCase() > b.word.toUpperCase() ? 1 : -1))
      this.doFilter();
    });
  }

  public changeSearch(e) {
    this.searchWord = e.detail.value;
    this.showPages = false;
    this.doFilter();
  }

  doFilter() {
    this.filteredWordList = this.wordList.filter((w) => (w.word.toUpperCase().indexOf(this.searchWord.toUpperCase()) > -1));
  }

  selectWord(w) {
    this.analyticsService.logEvent("search_term_selected","search",{ term: w.word, filter: this.searchWord });
    this.selectedWord = w.word;
    this.pageList = w.links;
    this.showPages = true;
  }

  selectPage(p) {
    this.analyticsService.logEvent("open_from_search",p.pageRef,{ page: p.pageRef, term: this.selectedWord, filter: this.searchWord });
    this.localContentService.requestPageDisplay(p.pageRef);
  }

  cancelSearch(w) {
    this.showPages = false;
    this.selectedWord = "";
    this.doFilter();
  }

}
